module.exports = __webpack_public_path__ + "img/price.cfa01318.png";